import type { Token } from '@ui/config/token';
import type { NormalToken } from '@ui/config/token/types';
import { create } from 'zustand';

interface TokenSelectDialogStore {
  isOpen: boolean;
  onSelectToken: null | ((token: Token) => void);
  open: (options: {
    onSelectToken: (token: Token) => void;
    tokenList?: NormalToken[];
  }) => void;
  close: () => void;
  tokenList?: NormalToken[];
}

export const useTokenSelectDialog = create<TokenSelectDialogStore>((set) => ({
  isOpen: false,
  onSelectToken: null,
  tokenList: undefined,
  close: () => {
    set({
      isOpen: false,
      tokenList: undefined,
    });
  },
  open: ({ onSelectToken, tokenList }) => {
    set({
      isOpen: true,
      onSelectToken,
      tokenList,
    });
  },
}));
